var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "items-list accordion",
      attrs: { id: "accessory-selector-shelves" },
    },
    _vm._l(_vm.shelves, function (shelf) {
      return _c(
        "li",
        { key: shelf.seoId + "-" + _vm.device },
        [
          _c(
            "selector-shelf",
            _vm._g(
              {
                ref: "selectorShelf",
                refInFor: true,
                staticClass: "items-list-item",
                attrs: {
                  device: _vm.device,
                  "shelf-id": shelf.seoId + "-" + _vm.device,
                  label: shelf.label,
                  "show-all-check-box": shelf.showAllCheckBox,
                  "check-boxes": shelf.checkBoxes,
                  show: shelf.show,
                  "is-multi-shelf": _vm.isMultiShelf,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }